import { components, GroupBase, DropdownIndicatorProps, ControlProps } from 'react-select';
import { SearchIcon } from '../../../icons';

export const SearchIndicator = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: DropdownIndicatorProps<Option, IsMulti, Group>
) => {
    const { height } = props.getStyles('control', props as ControlProps<Option, IsMulti, Group>);
    return (
        <components.DropdownIndicator {...props}>
            <SearchIcon
                margin="0 8px 0 0"
                cursor="pointer"
                width={`calc(${height} * .5)`}
                height={`calc(${height} * .4)`}
            />
        </components.DropdownIndicator>
    );
};
